import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import "core-js/modules/es6.array.iterator.js";
import "core-js/modules/es6.promise.js";
import "core-js/modules/es6.object.assign.js";
import "core-js/modules/es7.promise.finally.js";
//
//
//
//
//
//
//
//
export default {
  name: 'MdmLink',
  props: {
    url: {
      type: String,
      required: true
    },
    isNuxt: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    link: function link() {
      return _defineProperty({}, this.isNuxt ? 'to' : 'href', this.url);
    },
    component: function component() {
      return this.isNuxt ? 'nuxt-link' : 'a';
    }
  }
};